import React, { useEffect, useState } from 'react'

const useDocumentPosition = (ref, axis = 'top', onFixed) => {
  // Fixed Position State
  const [fixedPosition, setFixedPosition] = useState(false)

  useEffect(() => {
    // Handlescroll functions
    const bodyTop = document.body.getBoundingClientRect().top
    const initialTop = ref.current.getBoundingClientRect()[axis]
    const offSet = initialTop - bodyTop
    const handleScroll = () => {
      onFixed && onFixed(window.scrollY > offSet)

      setFixedPosition(window.scrollY > offSet)
    }

    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return {
    fixedPosition,
  }
}

export default useDocumentPosition
